import React from 'react';

import InformationCircle from '@videoblocks/react-icons/InformationCircle';

// RFPC-1334: "100% human-made content" tag shown near the search results count for all
// users on all search pages when the `messaging_updates` experiment is in the `test`
// variant. Matches Figma node 852:17767. Uses the `green-ai` design-system colors.
const AI_STATEMENT_URL =
  'https://www.storyblocks.com/resources/news/storyblocks-ai-statement';
const POLICY_TOOLTIP =
  'We have a zero generative AI policy for our library content, so everything is human-made.';

function HumanMadeTag() {
  return (
    <div
      className="inline-flex items-center gap-1 pl-2 pr-1 py-0.5 rounded-full text-sm bg-green-ai-100 text-green-ai-900"
      data-cy="humanMadeTag"
    >
      <span className="whitespace-nowrap">100% human-made content</span>
      <a
        href={AI_STATEMENT_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={POLICY_TOOLTIP}
        title={POLICY_TOOLTIP}
        className="inline-flex"
      >
        <InformationCircle className="w-4 h-4 fill-current" />
      </a>
    </div>
  );
}

export default HumanMadeTag;
